<template>
  <div>
    <!-- Start banner -->
    <contact-banner></contact-banner>
    <!-- End banner -->
    <div
      class="contact-content">
      <!--  Form and map -->
      <contact-form-map></contact-form-map>
      <!-- End form and map -->
      <!-- Start disclamer -->
      <contact-form-disclamers></contact-form-disclamers>
      <!-- End disclamer -->
    </div>
  </div>
</template>
<script>
export default {
  components: {
    // banner
    ContactBanner: () => import('@/components/Contact/Banner.vue'),
    // form and map
    ContactFormMap: () => import('@/components/Contact/MapForm.vue'),
    // disclamers
    ContactFormDisclamers: () => import('@/components/Contact/Disclamers.vue'),
  }
}
</script>
<style scoped>
  .content-polygon {
    z-index: 2;
    position: relative;
    background-color: white;
    clip-path: polygon(0 0,100% 100%,100% 0,100% 10%,100% 100%,0 100%);
    height: 150px;
    width: 100%;
  }
  .contact-content {
    max-width: 100vw;
    overflow: hidden;
    padding-top: 100vh;
    position: relative;
  }
</style>